export const Config = {
    // @ts-ignore
    GRAPHQL_API: window._env_.GRAPHQL_API,
    JWT_AUTH_HEADER_PREFIX: 'Bearer',
    // @ts-ignore
    MEDIA_URL: window._env_ ? window._env_.MEDIA_URL : ''
};
